import { getSiteSettingsApiConfig } from '../config/actions';
/**
 * @internal
 */
export var getSiteSettingsUrl = function (scope) {
    var relativeUrl = getSiteSettingRelativeUrl(scope);
    var baseUrl = getSiteSettingsApiConfig().baseUrl;
    return baseUrl + "/" + relativeUrl;
};
/**
 * @internal
 */
export var getSiteSettingRelativeUrl = function (scope) {
    var _a = getSiteSettingsApiConfig(), siteContext = _a.siteContext, marketLocale = _a.marketLocale;
    var scopes = Array.isArray(scope) ? scope.join(',') : scope;
    return "api/v1/settings?site=" + siteContext + "&marketLocale=" + marketLocale + "&scope=" + scopes;
};
